export const BRAND_NAME = "MiroFish";
export const BRAND_SLUG = "mirofish";
export const BRAND_TAGLINE =
  "A simple and universal swarm intelligence engine";
export const VISIBLE_LOGO_SRC = "/images/mirofish/orbital-swarm-mark.png";
export const BRAND_OG_IMAGE_SRC = "/images/mirofish/logo-reference.jpg";
export const PRIMARY_DOMAIN = "mirofish.my";
export const PRIMARY_URL = `https://${PRIMARY_DOMAIN}`;
export const OPERATOR_NAME = "MiroFish";
export const OPERATOR_URL = PRIMARY_URL;
export const SUPPORT_EMAIL = "support@mirofish.my";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
